import React from "react";
import { warningsType } from "../../../common/types/search/search";

export function Warnings({ warnings }: { warnings?: warningsType }) {
	if (!warnings || warnings.isEmpty()) {
		return null;
	}

	return (
		<ul className="warnings disclaimers">
			{warnings.map((warning, index) => (
				<li key={index} className="disclaimer">
					{warning}
				</li>
			))}
		</ul>
	);
}
